import { API_ENDPOINTS } from '../endpoints';

export const getGoldBox = async (protectedClient) => {
    const response = await protectedClient.get(API_ENDPOINTS.GOLD_BOX);
    return response.data.data;
};
